import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { StyledScrollContainer } from '../../../components/StyledScrollContainer'

// @components
import {
    Button,
    Typography,
    Card,
} from "@material-tailwind/react";
import { Refresh } from "iconoir-react";
import { RootState } from '../../../redux';
import { listPreQualifyRequest, PreQualify } from '../../../redux/auth/actions';

const TABLE_HEAD = [
    {n: "PipeDrive Deal", className: "pl-4"},
    {n: "Email", className: "pl-4"},
    {n: "Name", className: "pl-4"},
    {n: "VIN", className: "pl-4"},
    {n: "Preview", className: "pl-4"},
    {n: "Data", className: "pl-4"},
    {n: "", className: "pl-4"},
];

const DashboardPreQualifyInquiry = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { pre_qualify_inquiries } = useSelector((state: RootState) => state.auth);

    const handleRefresh = () => {
        dispatch(
            listPreQualifyRequest()
        );
    };

    useEffect(() => {
        handleRefresh();
    }, [dispatch]);

    return (
        <div className="flex flex-col gap-y-5 mt-5 text-black w-full">
            <Card>
                <Card.Header className="w-full m-0 items-center rounded-none flex  justify-between p-4">
                    <div className="grow">
                        <Typography
                            type="lead"
                            color="default"
                            className="font-semibold mb-1"
                        >
                            Pre-Qualify Inquiry
                        </Typography>
                        <Typography type="small" className="text-foreground block">
                            All pre-qualify inquiries
                        </Typography>
                    </div>
                    <div className="flex flex-col sm:flex-row items-center w-full shrink-0 gap-3 md:w-max">
                        <Button
                            variant="outline"
                            color="secondary"
                            className="flex items-center gap-2 sm:w-auto w-full"
                            onClick={() => {
                                handleRefresh();
                            }}
                        >
                            <Refresh className="w-4 h-4" />
                        </Button>
                    </div>
                </Card.Header>
                <StyledScrollContainer className="">
                    <Card.Body className="p-0 rounded-none">
                        <table className="w-full min-w-max table-auto text-left">
                            <thead>
                                <tr>
                                    {TABLE_HEAD.map((head, idx:number) => (
                                        <th key={idx} className={`border-b border-surface p-4 ${head.className}`}>
                                            <Typography
                                                type="small"
                                                color="default"
                                                className="block font-medium"
                                            >
                                                {head.n}
                                            </Typography>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {pre_qualify_inquiries?.filter((el: PreQualify) => !el.data.credit_score).map((el: PreQualify, key: number) => (
                                    <tr key={key} className="group cursor-pointer" onClick={() => {
                                        navigate(`/pre-qualify/?id=${el.id}`);
                                    }}>
                                        <td className="p-4 border-b border-surface group-last:border-none">
                                            <Typography type="small" className="block text-foreground font-bold">
                                                {el?.deal_id ? (
                                                    <a
                                                        href={`https://turbocar.pipedrive.com/deal/${el?.deal_id}`}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        className="text-info"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                        }}
                                                    >
                                                        View in PipeDrive
                                                    </a>) : (
                                                        'N/A'
                                                    )
                                                }
                                            </Typography>
                                        </td>
                                        <td className="p-4 border-b border-surface group-last:border-none">
                                            <Typography type="small" className="block text-foreground font-bold">
                                                {el?.data?.email || 'N/A'}
                                            </Typography>
                                        </td>
                                        <td className="p-4 border-b border-surface group-last:border-none">
                                            <Typography type="small" className="block text-foreground font-bold">
                                                {el?.data?.first_name || 'N/A'}{' '}
                                                {el?.data?.last_name || 'N/A'}
                                            </Typography>
                                        </td>
                                        <td className="p-4 border-b border-surface group-last:border-none">
                                            <Typography type="small" className="block text-foreground font-bold">
                                                {el?.data?.vin || 'N/A'}
                                            </Typography>
                                        </td>
                                        <td className="p-4 border-b border-surface group-last:border-none">
                                            <Typography type="small" className="block text-foreground">
                                                {JSON.stringify(el.data).slice(0, 100)}
                                            </Typography>
                                        </td>
                                        <td className="p-4 border-b border-surface group-last:border-none">
                                            <Typography type="small" className="block text-foreground">
                                                {el.date_added || 'N/A'}
                                            </Typography>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Card.Body>
                </StyledScrollContainer>
            </Card>
        </div>
    );
};

export default DashboardPreQualifyInquiry;